import { z } from "zod";
import { ACTIVITY_CATEGORIES, RECOMMENDATION_SOURCES } from "@/lib/enums";

/**
 * Zod schemas for the Activity Suggestion entity. `entryId` is nullable and
 * optional throughout — suggestions are standalone by default, optionally
 * linked to one PTO Entry.
 */
const baseObject = z.object({
  title: z.string().min(1, "Title is required").max(200, "Title is too long"),
  note: z.string().max(2000, "Note is too long").nullish(),
  entryId: z.string().nullish(),
  // Tags the suggestion for EPIC-008's curated-fallback filtering. Exposed in
  // the create/edit form's Category field.
  category: z.enum(ACTIVITY_CATEGORIES).nullish(),
  // Omitted by the plain manual form (defaults server-side to "curated").
  // EPIC-009's generate-and-pick flow sends this explicitly.
  source: z.enum(RECOMMENDATION_SOURCES).nullish(),
});

// What the API accepts on POST — and what the create/edit form collects directly.
export const createActivitySuggestionSchema = baseObject;
export type ActivitySuggestionFormValues = z.infer<typeof createActivitySuggestionSchema>;

// PUT is a partial update — every field optional.
export const updateActivitySuggestionSchema = baseObject.partial();

export type CreateActivitySuggestionInput = z.infer<typeof createActivitySuggestionSchema>;
export type UpdateActivitySuggestionInput = z.infer<typeof updateActivitySuggestionSchema>;
